import axios from 'axios';
import { parseApiError } from './parseApiError';

export const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  withCredentials: true
});

// configura o interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const parsed = parseApiError(error, {
      404: 'Registro não encontrado.',
      500: 'Erro interno do servidor. Tente novamente mais tarde.',
    });

    // anexa para uso downstream
    error.parsed = parsed;

    return Promise.reject(error);
  }
);